import { Login } from '../components/Login'

const LoginPage = ({
  loginUrl,
  passwordResetUrl,
  registrationUrl,
  csrfTokens,
  labels,
  errorMessage = '',
}) => {
  return (
    <>
      <section className="page-header is-inview" data-scroll-section>
        <div className="container" data-scroll>
          <Login
            csrfTokens={csrfTokens}
            labels={labels}
            loginUrl={loginUrl}
            passwordResetUrl={passwordResetUrl}
            registrationUrl={registrationUrl}
            errorMessage={errorMessage}
          />
        </div>
      </section>
    </>
  )
}

export default LoginPage
